/* eslint-disable react/prop-types */
import React, { useReducer, useEffect, ReactNode } from 'react'

import { TogetherComponentGlobalContextProvider } from '@hhgtech/hhg-components/together'
import type { AppProps } from 'next/app'
import Router from 'next/router'
import NProgress from 'nprogress' //nprogress module
import { useIntl } from 'react-intl'

import { getHelloSitesUrl } from 'api/utils/paths'
import { showNotification } from 'components/molecules/notificationsHandler'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { ENABLE_ACCEPT_COOKIE_MODAL_LOCALES } from 'interfaces/constants'
import { UserInfo } from 'interfaces/types'
import { AppContext } from 'state/appContext'
import { appReducer } from 'state/appReducer'
import { initialState } from 'state/initialState'
import { State } from 'state/types'
import { sanitize } from 'utils/post'
// declare let google: any
export function AppContextWrapper({
  pageProps,
  children,
}: {
  pageProps?: AppProps<{
    isMobileSsr?: boolean
    userInfo?: UserInfo
    page?: string
  }>['pageProps']
  children: ReactNode
}) {
  const { locale, router } = useRouterExtend()

  const { isMobileSsr = false, userInfo } = pageProps || {}
  const enhancedState: State = {
    ...initialState,
    isMobileSsr,
    userInfo: userInfo || undefined,
    isLoggedIn: !!userInfo?.id,
    newBookmark: [],
    currentDomain: getHelloSitesUrl(locale),
  }
  const { formatMessage } = useIntl()
  const [state, dispatch] = useReducer(appReducer, enhancedState)

  useEffect(() => {
    NProgress.configure({ showSpinner: false })
    setTimeout(() => {
      Router.events.on('routeChangeStart', () => NProgress.start())
    }, 100)
    Router.events.on('routeChangeComplete', () => NProgress.done())
    Router.events.on('routeChangeError', () => NProgress.done())
  }, [])

  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      (ENABLE_ACCEPT_COOKIE_MODAL_LOCALES || [])?.includes(locale)
    ) {
      window.consentListeners = []
      window.addConsentListenerExample = (callback) => {
        window.consentListeners.push(callback)
      }
    }
  }, [])

  return (
    <AppContext.Provider
      value={{
        state,
        dispatch,
      }}
    >
      <TogetherComponentGlobalContextProvider
        userInfo={state?.userInfo as any}
        locale={locale}
        router={router}
        pushNotifications={showNotification}
        sanitizeFunction={sanitize}
        env={{
          togetherBasePath: '/community',
          publicSSO: process.env.NEXT_PUBLIC_SSO,
          togetherBaseApiUrl: process.env.NEXT_PUBLIC_TOGETHER_API,
          discoverBaseApiUrl: process.env.NEXT_PUBLIC_BASE_API_URL,
          discoverBaseProdApiUrl: process.env.NEXT_PUBLIC_BASE_PROD_API_URL,
          marryBabyApiUrl:
            process.env.NEXT_PUBLIC_DISCOVER_MARRY_BABY_BASE_API_URL,
          marryBabyProdApiUrl:
            process.env.NEXT_PUBLIC_DISCOVER_MARRY_BABY_BASE_PROD_API_URL,
          careBaseApiUrl: process.env.NEXT_PUBLIC_CARE_API,
          subotApiUrl: process.env.NEXT_PUBLIC_SUBOT_API,
          leadApiUrl: process.env.NEXT_PUBLIC_LEAD_API,
          chatbotAiUrl: process.env.NEXT_PUBLIC_CHATBOT_API_URL,
        }}
        formatMessage={formatMessage}
      >
        {children}
      </TogetherComponentGlobalContextProvider>
    </AppContext.Provider>
  )
}
